import { useMemo } from 'react';
import { useTheme } from '@mui/material';

import { DEFAULT_ZOOM, MAX_ZOOM, MIN_ZOOM } from '../store-locator.constants';

export const useOptions = () => {
  const { palette } = useTheme();

  return useMemo(
    () => ({
      zoom: DEFAULT_ZOOM,
      minZoom: MIN_ZOOM,
      maxZoom: MAX_ZOOM,
      disableDefaultUI: true,
      mapId: palette.googleMapsMapId,
    }),
    [palette.googleMapsMapId],
  );
};
